import styled from 'styled-components';
import { Spinner, colors } from '@zopauk/react-components';

interface PlaceholderProps {
  type: 'discovery' | 'primary';
}

const PlaceholderCard = styled.div<{ $type: PlaceholderProps['type'] }>`
  position: relative;
  border: 1px solid ${colors.greyLighter};
  border-radius: 12px;
  padding: 24px;
  height: ${({ $type = 'primary' }) => ($type === 'discovery' ? '166px' : '100px')};
  width: 100%;
  background-color: ${colors.white};
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Placeholder = ({ type }: PlaceholderProps) => (
  <PlaceholderCard $type={type}>
    <Spinner />
  </PlaceholderCard>
);
